import { AddBikeForm } from '@/components/dashboard/AddBikeForm';

export default function HostAddBike() {
  return <AddBikeForm />;
}
